export default function () {
  let visible = true;
  const sidePanelControl = document.querySelector('#rwg-side-panel-ctrl');
  const sidePanel = document.querySelector('#sidebarTabs');
  const mapPanel = document.querySelector('#mapAndStatus');
  const mapPanelRight = mapPanel.style.right;  // save initial value so that this doesn't have to be in sync w/ css

  function hide() {
    sidePanel.style.display = 'none';
    mapPanel.style.right = '0';
    sidePanelControl.title = 'Show side panel';
    sidePanelControl.style.cursor = 'w-resize';
    window.dispatchEvent(new Event('resize'));
    visible = false;
  }

  function show() {
    sidePanel.style.display = '';
    mapPanel.style.right = mapPanelRight;
    sidePanelControl.title = 'Hide side panel';
    sidePanelControl.style.cursor = 'e-resize';
    window.dispatchEvent(new Event('resize'));
    visible = true;
  }

  sidePanelControl.addEventListener('click', () => visible ? hide() : show());

  return {
    show: () => { if (!visible) show() },
    hide: () => { if (visible) hide() },
  }
}
